import { render } from "./AddCategoryModal.vue?vue&type=template&id=a0e6685e"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__